/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react';
import { CookiesProvider } from 'react-cookie';
import './src/styles/global.css'
import CookieConsent from './src/components/CookieConsent';
import * as Sentry from "@sentry/gatsby";
import { SENTRY_DSN } from "./src/utils/constants";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: "production",
  initialScope: {
    tags: { app: "staking" },
  },
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});

export const wrapRootElement = ({ element }) => {
    return (
      <div>
        {element}
        <CookiesProvider>
          <CookieConsent />
        </CookiesProvider>
      </div>
    );
  };